import { Tooltip, withStyles } from "@material-ui/core";

export const TooltipArrowDown = withStyles(
  {
    tooltip: {
      "&:after": {
        borderColor: "#2b3039 transparent transparent transparent",
        borderStyle: "solid",
        borderWidth: "10px 10px 0 10px",
        content: "' '",
        left: "50%",
        marginLeft: "-10px",
        position: "absolute",
        top: "100%"
      },
      backgroundColor: "#2b3039",
      fontSize: "1em",
      left: 20,
      marginLeft: 0,
      position: "relative"
    }
  },
  { name: "TooltipArrowDown" }
)(Tooltip);

export const TooltipArrowUp = withStyles(
  {
    tooltip: {
      "&:after": {
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        borderTop: "15px solid #2b3039",
        borderWidth: "10px 10px 0 10px",
        bottom: "100%",
        content: "' '",
        height: 0,
        left: "50%",
        marginLeft: "-15px",
        position: "absolute",
        transform: "rotate(-180deg)",
        width: 0
      },
      backgroundColor: "#2b3039",
      bottom: 0,
      fontSize: "1em",
      position: "relative"
    }
  },
  { name: "TooltipArrowUp" }
)(Tooltip);

export const TooltipArrowLeft = withStyles(
  {
    tooltip: {
      "&:after": {
        borderColor: "transparent #2b3039 transparent transparent",
        borderStyle: "solid",
        borderWidth: 5,
        content: "' '",
        marginTop: -5,
        position: "absolute",
        right: "100%",
        top: "50%"
      },
      backgroundColor: "#2b3039",
      fontSize: "1em",
      left: 20,
      marginLeft: 0,
      position: "relative"
    }
  },
  { name: "TooltipArrowLeft" }
)(Tooltip);

export const TooltipArrowLeftRadioField = withStyles(
  {
    tooltip: {
      "&:after": {
        borderColor: "transparent #2b3039 transparent transparent",
        borderStyle: "solid",
        borderWidth: 5,
        content: "' '",
        marginTop: -5,
        position: "absolute",
        right: "100%",
        top: "50%"
      },
      backgroundColor: "#2b3039",
      bottom: 60,
      fontSize: "1em",
      left: 20,
      marginLeft: 0,
      position: "relative"
    }
  },
  { name: "TooltipArrowLeftRadioField" }
)(Tooltip);
